/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HideViewedFilterSchemaTimeUnit = typeof HideViewedFilterSchemaTimeUnit[keyof typeof HideViewedFilterSchemaTimeUnit] | null;


export const HideViewedFilterSchemaTimeUnit = {
  days: 'days',
  weeks: 'weeks',
  months: 'months',
  years: 'years',
} as const;
